import { atom } from 'jotai';

/**
 * Atom for managing setup intent popup open state
 */
export const setupIntentPopupOpenAtom = atom<boolean>(false);

/**
 * Atom for storing the current customer ID for setup intent
 */
export const setupIntentPopupCustomerIdAtom = atom<number>(0);

/**
 * Atom for storing the Stripe account for setup intent
 */
export const setupIntentPopupStripeAccountAtom = atom<string | null>(null);

/**
 * Atom for storing payment data for setup intent (amount and currency)
 */
export const setupIntentPopupPaymentDataAtom = atom<{
    amount: number;
    currency: string;
} | null>(null);

/**
 * Atom for storing the invoice payment ID for setup intent
 */
export const setupIntentPopupInvoicePaymentIdAtom = atom<string | null>(null);
